import { render, staticRenderFns } from "./TimetableNotes.vue?vue&type=template&id=61e75e54&"
import script from "./TimetableNotes.vue?vue&type=script&lang=js&"
export * from "./TimetableNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports